module.exports = "/_next/static/images/trans-f2cb82d03e983017c23dd1a5baae5979.png";